import { render, staticRenderFns } from "./CheckTOTPCode.vue?vue&type=template&id=b46dede4&scoped=true"
import script from "./CheckTOTPCode.vue?vue&type=script&lang=ts"
export * from "./CheckTOTPCode.vue?vue&type=script&lang=ts"
import style0 from "./CheckTOTPCode.vue?vue&type=style&index=0&id=b46dede4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b46dede4",
  null
  
)

export default component.exports